import script from "./ForumWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumWidget.vue?vue&type=script&setup=true&lang=js"

import "./ForumWidget.vue?vue&type=style&index=0&id=6d3c38c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d3c38c8"]])

export default __exports__